export const EditingModes = {
  Normal: 1,
  Advanced: 2
}
